// src/components/home/FounderSection.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Founder assets
import founderImg from '../../assets/Founder-doctor.png';
import BGImg from '../../assets/background_green.jpg';
import goldenLeaf from '../../assets/leaf1.png'; // using leaf1 with golden filter

const FounderSection = () => {
  const navigate = useNavigate();
  
  const range = 40; // rotation range
  const calcValue = (a, b) => (a / b * range - range / 2).toFixed(1);
  
  useEffect(() => {
    const founderCards = document.querySelectorAll(".founder-parallax-card");
    let timeout;
    
    const handleMouseMove = (e) => {
      if (timeout) window.cancelAnimationFrame(timeout);
      timeout = window.requestAnimationFrame(() => {
        const yValue = calcValue(e.clientY, window.innerHeight);
        const xValue = calcValue(e.clientX, window.innerWidth);
        /* --------------------
     FOUNDER CARD (New Dedicated Block)
  -------------------- */
        founderCards.forEach(card => {
          card.style.transform = `rotateX(${yValue}deg) rotateY(${xValue}deg)`;
          const img = card.querySelector(".founder-parallax-card__img");
          const bg = card.querySelector(".founder-parallax-card__bg");
          if (img) {
            img.style.transform = `
              translateX(${-xValue * 1.5}px)
              translateY(${yValue * 1.5}px)
              translateZ(80px)
            `;
          }
          if (bg) {
            bg.style.backgroundPosition = `
              ${xValue * 0.45}px
              ${-yValue * 0.45}px
            `;
          }
        });
      });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  return (
<section className="relative bg-gradient-to-b from-[#F8F3EA] to-[#E8E0D5] py-24 md:py-32 overflow-hidden">
  {/* Floating Golden Leaves Background Animation */}
  <div className="absolute inset-0 pointer-events-none overflow-hidden">
    {[...Array(6)].map((_, i) => (
      <img
        key={i}
        src={goldenLeaf}
        alt=""
        className="absolute w-32 md:w-48 opacity-20 animate-float"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animationDelay: `${i * 1.5}s`,
          animationDuration: `${15 + i * 5}s`,
          filter: 'sepia(0.6) hue-rotate(40deg) brightness(1.4)',
        }}
      />
    ))}
  </div>
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      {/* Left: Animated Floating Portrait */}
{/* Left: Founder Portrait with Exclusive 3D Parallax */}
<div className="relative flex justify-center lg:justify-end lg:mr-16">
  <div className="relative animate-float-slow">
    {/* Pulse Glow */}
    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-amber-400/30 to-emerald-400/20 blur-3xl scale-110 animate-pulse-slow -z-10"></div>

    {/* === FOUNDER-SPECIFIC PARALLAX CARD === */}
    <div className="founder-parallax-card w-80 h-80 md:w-96 md:h-96 lg:w-[480px] lg:h-[480px] rounded-2xl overflow-hidden shadow-2xl border-8 border-white cursor-pointer">
      
      {/* Background Layer */}
      <div 
        className="founder-parallax-card__bg absolute inset-0"
        style={{
          backgroundImage: `url(${BGImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.75) blur(2px)',
        }}
      />

      {/* Foreground Sharp Image */}
      <img
        src={founderImg}
        alt="Dr. V. K. Subrahmanyeswar Rao - Founder"
        className="founder-parallax-card__img w-full h-full object-cover object-top"
      />
    </div>

    {/* Badge stays on top */}
    <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#0B2A2C] to-[#1A4D4F] text-white px-8 py-3 rounded-full text-lg font-medium shadow-2xl whitespace-nowrap animate-fade-up delay-700 z-50">
      Visionary Healer & Founder
    </div>
  </div>
</div>
      {/* Right: Staggered Text Reveal Content */}
      <div className="space-y-8 md:space-y-10 text-center lg:text-left">
        {/* Badge */}
        <div className="inline-flex items-center gap-3 text-[#0B2A2C] animate-fade-up delay-200">
          <span className="text-3xl"></span>
          <span className="font-medium tracking-widest uppercase text-sm">The Soul Behind Ayusanjivni</span>
        </div>
        {/* Name */}
        <h2 className="text-4xl md:text-5xl lg:text-4xl font-bold text-[#0B2A2C] leading-tight animate-fade-up delay-300 font-playfair">
          Dr. V. K. Subrahmanyeswara Rao
        </h2>
        <span className="text-lg md:text-xl text-amber-700 font-semibold whitespace-nowrap animate-fade-up delay-400">
  - MD Gold Medalist
</span>
        {/* Quote with golden line */}
        <div className="relative animate-fade-up delay-500">
          <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-amber-500 to-transparent hidden lg:block"></div>
          <blockquote className="font-joan text-lg md:text-2xl lg:text-2xl font-bold text-[#0B2A2C]/85 leading-relaxed pl-0 lg:pl-8 max-w-3xl">
            “Ayurveda is not just medicine — it is the art of living in rhythm with nature’s eternal wisdom.”
          </blockquote>
        </div>
        {/* Description paragraphs – appear one after another */}
        <p className="font-joan text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl animate-fade-up delay-700">
          Dr. V. K. Subrahmanyeswar Rao has dedicated over a decade to practicing and teaching authentic Ayurveda. Trained under experienced gurus in the traditional Gurukula system, he has focused on preserving and reviving Panchakarma techniques. His work is centered on sharing the knowledge of Ayurveda to promote well-being and holistic health.
        </p>
        <p className="font-joan text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl animate-fade-up delay-900">
He is committed to combining traditional practices with a practical approach suited to modern lifestyles. Through his guidance, many individuals have gained a deeper understanding of Ayurveda and its benefits for maintaining balance and overall wellness.        </p>
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-6 animate-fade-up delay-1100">
          <button
            onClick={() => navigate("/founder")}
            className="bg-[#0B2A2C] text-white px-10 py-4 rounded-full text-lg font-medium hover:bg-[#1A3D3F] transition transform hover:-translate-y-1 shadow-xl">
            Read His Full Journey →
          </button>
          <button className="border-2 border-[#0B2A2C] text-[#0B2A2C] px-10 py-4 rounded-full text-lg font-medium hover:bg-[#0B2A2C] hover:text-white transition">
            Watch Message Video
          </button>
        </div>
      </div>
    </div>
  </div>
</section> 
  );
};

export default FounderSection;